<mat-card>
    <mat-card-content>
        <img src="assets/images/MDR/MDR_about_box.png" alt="Medical Device Regulation" />

        <p>
            {{ version$ | async }}
        </p>
    </mat-card-content>

    <mat-card-actions align="end">
        <button mat-button mat-dialog-close>
            <span translate>Close</span>
        </button>
    </mat-card-actions>
</mat-card>
